import { render, staticRenderFns } from "./SeferTorahAddModal.vue?vue&type=template&id=1bb59ae1&scoped=true&"
import script from "./SeferTorahAddModal.vue?vue&type=script&lang=js&"
export * from "./SeferTorahAddModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bb59ae1",
  null
  
)

export default component.exports